import * as Sentry from "@sentry/nextjs";

//const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
Sentry.init({
  //dsn: 'http://01e5cd7533584577ba09b9ff02a4397c@54.159.168.165:9000/4',
  dsn: 'https://01e5cd7533584577ba09b9ff02a4397c@sentry-int.oneday.io/4',
  tracesSampleRate: 0.25,
});